import {  Route, Routes } from "react-router";
import { Layout } from "../Layout/Layout";
import Customer360 from "../pages/customer360/Customer360";
import { ROUTES } from "../route/RouteConstant";
import ChatApp from "../pages/chatbot/ChatPage";

export const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route path={ROUTES.CUSTOMER_360} element={<Customer360 />} />
        <Route path="/neuron/chatbot" element={<ChatApp/>}/>
        {/* Add more routes as needed */}
      </Route>
    </Routes>
  );
};
